
  import { ClassI } from '../interfaces/Class'
  import { defineComponent } from 'vue'
  import Modal from '../components/Modal.vue'
  import Sidebar from '../components/Sidebar.vue'
  import LoadingIcon from '../components/LoadingIcon.vue'

  export default defineComponent({
    name: 'Class',
    components: {
      Sidebar,
      Modal,
      LoadingIcon,
    },
    props: {
      classCode: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        currClass: {} as ClassI,
        modalIsVisible: false,
        isLoading: false,
      }
    },
    methods: {
      toggleModalVisibility(): void {
        this.modalIsVisible = !this.modalIsVisible
      },
      callLeaveClass(): void {
        this.$store.dispatch('classes/leaveClass', this.classCode)
        this.toggleModalVisibility()
      },
    },
    async mounted() {
      this.isLoading = true
      // find name of class
      // note: can store in order of class code and do a binary search for
      // O(log n) time instead of O(n)
      const allClasses = this.$store.state.classes.classes.concat(
        this.$store.state.classes.classesTeaching
      )
      for (let i = 0; i < allClasses.length; i++) {
        if (allClasses[i].classCode == this.classCode) {
          this.currClass = allClasses[i]
        }
      }

      if (this.$store.state.auth.isTeacher) {
        await this.$store.dispatch(
          'classes/getAssignedDecksAsTeacher',
          this.classCode
        )
      } else {
        await this.$store.dispatch(
          'classes/getAssignedDecksAsStudent',
          this.classCode
        )
      }
      this.isLoading = false
    },
  })
